///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { API } from "./axios";
import { stringify } from "query-string";

export const getCapacityMatchLanesSummary = (
  bidId,
  userRoleForBidWhenManagementUser
) =>
  API.post(`api/v1.0/capacityMatch/${bidId}/lanes-summary`, null, {
    params: { userRoleForBidWhenManagementUser }
  });

export const acceptBidModeCapacityMatch = (
  bidId,
  bidModeId,
  userRoleForBidWhenManagementUser
) =>
  API.post(`api/v1.0/capacityMatch/${bidId}/mode/${bidModeId}/accept`, null, {
    params: { userRoleForBidWhenManagementUser }
  });

export const rejectBidModeCapacityMatch = (
  bidId,
  bidModeId,
  userRoleForBidWhenManagementUser
) =>
  API.post(`api/v1.0/capacityMatch/${bidId}/mode/${bidModeId}/reject`, null, {
    params: {
      userRoleForBidWhenManagementUser
    }
  });

export const submitBidModeCapacityMatch = (
  bidId,
  bidModeId,
  userRoleForBidWhenManagementUser
) =>
  API.post(`api/v1.0/capacityMatch/${bidId}/mode/${bidModeId}/submit`, null, {
    params: {
      userRoleForBidWhenManagementUser
    }
  });

export const getCarrierMatches = (
  truckloadLaneIds,
  bidId,
  userRoleForBidWhenManagementUser
) =>
  API.post(`/api/v1.0/capacityMatch/${bidId}/matches`, truckloadLaneIds, {
    params: {
      userRoleForBidWhenManagementUser
    }
  });

export const upsertLaneCarrierCapacityMatches = (
  bidId,
  laneCarrierCapacityMatches,
  userRoleForBidWhenManagementUser
) =>
  API.post(
    `/api/v1.0/capacityMatch/${bidId}/lane-matches`,
    laneCarrierCapacityMatches,
    { params: { userRoleForBidWhenManagementUser } }
  );

export const updateCapacityMatchingStatus = (
  bidId,
  bidModeId,
  capacityMatchingStatus,
  sendNotifications,
  userRoleForBidWhenManagementUser
) =>
  API.put(`api/v1.0/capacityMatch/${bidId}/${bidModeId}/status`, null, {
    params: {
      capacityMatchingStatus,
      sendNotifications,
      userRoleForBidWhenManagementUser:
        userRoleForBidWhenManagementUser === null
          ? undefined
          : userRoleForBidWhenManagementUser
    },
    paramsSerializer: params => stringify(params)
  });

export const getIsCapacityMatchingInProgress = (
  bidId,
  userRoleForBidWhenManagementUser
) =>
  API.get(`api/v1.0/capacityMatch/${bidId}/matching-in-progress`, {
    params: { userRoleForBidWhenManagementUser }
  });

export const runInternalCapacityMatching = (
  bidId,
  userRoleForBidWhenManagementUser
) =>
  API.post(`/api/v1.0/capacityMatch/${bidId}/run-matching`, null, {
    params: { userRoleForBidWhenManagementUser }
  });

export const getMatchesTemplateWithData = ({
  bidId,
  userRoleForBidWhenManagementUser
}) =>
  API.get(`api/v1.0/capacityMatch/${bidId}/export-matches`, {
    params: { userRoleForBidWhenManagementUser },
    responseType: "blob"
  });

export const getMatchingRunDate = (bidId, userRoleForBidWhenManagementUser) =>
  API.get(`api/v1.0/capacityMatch/${bidId}/matching-run-date`, {
    params: { userRoleForBidWhenManagementUser }
  });

export const getRateHistory = (
    truckloadLaneId,
    bidId
) =>
    API.get(`api/v1.0/capacityMatch/${bidId}/rate-history`, {
        params: { truckloadLaneId }
    });